import firebase from "firebase";

export interface DataSourceSummaryItem {
  documentId: string;
  label: string;
}

export interface DataSource {
  documentSummaries: DataSourceSummaryItem[];
  name: string;
  id: string;
  part: number;
}

export const dataSourceConverter = {
  toFirestore: function (database: DataSource) {
    throw new Error("Unimplemented");
  },

  fromFirestore: function (
    snapshot: firebase.firestore.QueryDocumentSnapshot
  ): DataSource {
    const data: firebase.firestore.DocumentData = snapshot.data();
    const summaries: firebase.firestore.DocumentData[] = data.summaries;
    const summary: firebase.firestore.DocumentData = data.summary;

    return {
      documentSummaries: summaries.map((summaryItem) => ({
        documentId: summaryItem.documentId as string,
        label: summaryItem.name as string,
      })),
      name: summary.name as string,
      id: summary.id as string,
      part: summary.part as number,
    };
  },
};
